import {
    Component,
    OnInit,
    HostListener,
    ViewChild,
    OnDestroy,
  } from '@angular/core';
  import { CommonModule } from '@angular/common';
  import { SidebarComponent } from './core/sidebar/sidebar.component';
  import { RouterLink, RouterOutlet } from '@angular/router';
  import { Router, NavigationEnd } from '@angular/router';
import { HeaderComponent } from './core/header/header.component';
import { BreadcrumbService } from './core/services/breadcrumb.service';
import { filter, Subscription } from 'rxjs';
import { NotificationService } from './features/notifications/services/notification.service';
  
  @Component({
    selector: 'app-root',
    standalone: true,
    imports: [
      SidebarComponent,
      CommonModule,
      HeaderComponent,
      RouterLink,
      RouterOutlet,
    ],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
  })
  export class AppComponent implements OnInit, OnDestroy {
    breadcrumbs: Array<any> = [];
    private subscriptions = new Subscription();

    title = 'etp-portal';
  
    dataFromLayout = false;
    isCollapsed = false;
    isSpecialRoute: boolean;
  
    constructor(private router: Router,private breadcrumbService: BreadcrumbService, private notificationService: NotificationService) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          const url = this.router.url.split('?')[0]; 
          this.isSpecialRoute = ['/login', '/forgot-password', '/reset-password'].includes(url);
        }
      });
    }
  
    @ViewChild(SidebarComponent) sidebarComponent: SidebarComponent;
  
    ngOnInit(): void {
      this.checkWindowSize();
      this.notificationService.loadNotifications().subscribe(() => {
        // this.myNotifications$ = this.store.select(selectNotifications);
        this.notificationService.startListening();
      });
      this.subscriptions.add(
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                this.breadcrumbs = this.breadcrumbService.getBreadcrumbs();
            })
    );
    }
  
    ngOnDestroy(): void {
      // No need to unsubscribe from router events
    }
  
    getBreadcrumbTitle(): string {
      return this.breadcrumbs.length ? this.breadcrumbs[0].name : 'Dashboard';
    }
  
    goBack(): void {
      if (this.breadcrumbs.length > 1) {
        const previousBreadcrumb = this.breadcrumbs[this.breadcrumbs.length - 2];
        this.router.navigate([previousBreadcrumb.path]);
      }
    }
  
    shouldShowBackButton(): boolean {
      return this.breadcrumbs.length > 1;
    }
  
    @HostListener('window:resize', ['$event'])
    onResize(event: Event): void {
      this.checkWindowSize();
    }
  
    toggleSidebar(): void {
      this.isCollapsed = !this.isCollapsed;
      this.dataFromLayout = !this.dataFromLayout;
      this.sidebarComponent.toggleExpansionPanel();
    }
  
    checkWindowSize(): void {
        const width = window.innerWidth;
        this.dataFromLayout = width > 768 && width < 1100;
        this.isCollapsed = width > 768 && width < 1100;
      }
    
      triggerSidebarOnce(): void {
        if (this.isCollapsed) {
          this.isCollapsed = false;
          this.dataFromLayout = false;
        }
      }
  }